import React, { createContext, useContext, useState, ReactNode } from 'react';

// 1. Define types
type TriggerAction = {
  name: string;
  payload: any; // You can replace 'any' with a more specific type if you know the shape
} | null;

type DashboardTriggerContextType = {
  triggerDashboard: (actionName: string, payload: any) => void; // Replace 'any' with specific payload type if possible
  triggerAction: TriggerAction;
  setTriggerAction: React.Dispatch<React.SetStateAction<TriggerAction>>;
};

// 2. Create Context with proper type (initially undefined to enforce provider usage)
const DashboardTriggerContext = createContext<DashboardTriggerContextType | undefined>(undefined);

// 3. Provider Component
type DashboardTriggerProviderProps = {
  children: ReactNode;
};

export const DashboardTriggerProvider: React.FC<DashboardTriggerProviderProps> = ({ children }) => {
  const [triggerAction, setTriggerAction] = useState<TriggerAction>(null);

  const triggerDashboard = (actionName: string, payload: any) => {
    setTriggerAction({ name: actionName, payload });
  };

  return (
    <DashboardTriggerContext.Provider value={{ triggerDashboard, triggerAction, setTriggerAction }}>
      {children}
    </DashboardTriggerContext.Provider>
  );
};

// 4. Custom hook for consuming the context safely
export const useDashboardTrigger = () => {
  const context = useContext(DashboardTriggerContext);
  if (context === undefined) {
    throw new Error('useDashboardTrigger must be used within a DashboardTriggerProvider');
  }
  return context;
};
